<template>
  <div class="user-list">
    <!-- <h2 class="text-xl font-semibold mb-4">用户列表</h2> -->
    
    <!-- 搜索和筛选 -->
    <el-card class="mb-4">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="搜索" class="search-item">
          <el-input
            v-model="searchQuery"
            placeholder="用户名、邮箱、手机号或单位名称"
            clearable
            @clear="handleSearch"
            class="search-input"
          >
            <template #append>
              <el-button @click="handleSearch">
                <el-icon><Search /></el-icon>
              </el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="状态" class="search-item">
          <el-select v-model="statusFilter" placeholder="账号状态" clearable @change="handleFilter">
            <el-option label="全部" value="" />
            <el-option label="待审核" value="pending" />
            <el-option label="已通过" value="approved" />
            <el-option label="已拒绝" value="rejected" />
          </el-select>
        </el-form-item>
        <el-form-item label="单位类别" class="search-item">
          <el-select v-model="organizationType" placeholder="选择单位类别" clearable @change="handleFilter">
            <el-option label="全部" value="" />
            <el-option label="科研院所" value="科研院所" />
            <el-option label="院校" value="院校" />
            <el-option label="航天部门" value="航天部门" />
            <el-option label="商业公司" value="商业公司" />
            <el-option label="行业部委" value="行业部委" />
            <el-option label="地方用户" value="地方用户" />
          </el-select>
        </el-form-item>
        <el-form-item label="个人职称" class="search-item">
          <el-select v-model="title" placeholder="选择个人职称" clearable @change="handleFilter">
            <el-option label="全部" value="" />
            <el-option label="博士" value="博士" />
            <el-option label="硕士" value="硕士" />
            <el-option label="学士" value="学士" />
            <el-option label="在读研究生" value="在读研究生" />
            <el-option label="在读本科生" value="在读本科生" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleExport">导出用户信息</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 用户表格 -->
    <el-card class="table-card">
      <template #header>
        <div class="card-header">
          <span class="text-lg font-medium">用户列表</span>
        </div>
      </template>

      <div class="table-container">
        <el-table
          v-loading="loading"
          :data="userList"
          style="width: 100%"
          border
          stripe
          size="small"
        >
          <el-table-column prop="id" label="ID" width="50" fixed="left" />
          <el-table-column prop="name" label="用户名" min-width="80" fixed="left" />
          <el-table-column prop="email" label="邮箱" min-width="120" show-overflow-tooltip />
          <el-table-column prop="phone" label="手机号" min-width="100" show-overflow-tooltip />
          <el-table-column prop="wechat_name" label="微信号" min-width="80" show-overflow-tooltip />
          <el-table-column prop="profession" label="单位类型" min-width="90" show-overflow-tooltip />
          <el-table-column prop="institution_name" label="单位名称" min-width="120" show-overflow-tooltip />
          <el-table-column prop="organization" label="个人学历" min-width="80" show-overflow-tooltip />
          <el-table-column prop="purpose" label="用途" min-width="120" show-overflow-tooltip />
          <el-table-column prop="status" label="状态" width="70" fixed="right">
            <template #default="{ row }">
              <el-tag :type="getStatusType(row.status)" size="small">
                {{ getStatusText(row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="注册时间" min-width="120" show-overflow-tooltip />
          <el-table-column label="操作" width="120" fixed="right">
            <template #default="{ row }">
              <div class="action-buttons">
                <el-button type="primary" link size="small" @click="handleEdit(row)">编辑</el-button>
                <el-button type="success" link size="small" @click="handleViewUsage(row)">使用情况</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>

    <!-- 编辑用户对话框 -->
    <el-dialog
      v-model="dialogVisible"
      title="编辑用户信息"
      width="500px"
      class="edit-dialog"
    >
      <el-form :model="editForm" label-width="100px" class="text-base">
        <el-form-item label="用户名">
          <el-input v-model="editForm.name" disabled />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="editForm.email" disabled />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="editForm.phone" disabled />
        </el-form-item>
        <el-form-item label="单位类型">
          <el-select v-model="editForm.profession" placeholder="选择单位类型">
            <el-option label="科研院所" value="科研院所" />
            <el-option label="院校" value="院校" />
            <el-option label="航天部门" value="航天部门" />
            <el-option label="商业公司" value="商业公司" />
            <el-option label="行业部委" value="行业部委" />
            <el-option label="地方用户" value="地方用户" />
          </el-select>
        </el-form-item>
        <el-form-item label="单位名称">
          <el-input v-model="editForm.institution_name" placeholder="请输入具体单位名称" />
        </el-form-item>
        <el-form-item label="个人职称">
          <el-select v-model="editForm.organization" placeholder="选择个人职称">
            <el-option label="博士" value="博士" />
            <el-option label="硕士" value="硕士" />
            <el-option label="学士" value="学士" />
            <el-option label="在读研究生" value="在读研究生" />
            <el-option label="在读本科生" value="在读本科生" />
          </el-select>
        </el-form-item>
        <el-form-item label="用途">
          <el-input v-model="editForm.purpose" type="textarea" />
        </el-form-item>
        <el-form-item label="微信号">
          <el-input v-model="editForm.wechat_name" placeholder="请输入微信号" />
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="editForm.password" type="password" placeholder="留空表示不修改密码" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSave">保存</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 使用情况对话框 -->
    <el-dialog
      v-model="usageDialogVisible"
      title="用户使用情况"
      width="500px"
      class="usage-dialog"
    >
      <div v-if="selectedUser" class="space-y-4 text-base">
        <div class="bg-gray-50 p-4 rounded">
          <h4 class="text-lg font-medium mb-2">基本信息</h4>
          <p>创建时间：{{ selectedUser.created_at }}</p>
          <p>更新时间：{{ selectedUser.updated_at }}</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { Search } from '@element-plus/icons-vue'
import axios from 'axios'

// 搜索和筛选
const searchQuery = ref('')
const statusFilter = ref('')
const keyword = ref('')
const organizationType = ref('')
const title = ref('')

// 分页相关
const currentPage = ref(1)
const pageSize = ref(10)
const total = ref(0)

// 用户列表
const userList = ref([])

// 编辑对话框
const dialogVisible = ref(false)
const editForm = ref({
  id: '',
  name: '',
  email: '',
  phone: '',
  profession: '',
  organization: '',
  purpose: '',
  status: '',
  password: '',
  institution_name: '',
  wechat_name: ''
})

// 使用情况对话框
const usageDialogVisible = ref(false)
const selectedUser = ref(null)

// 获取用户列表
const fetchUserList = async () => {
  try {
    const params = {
      page: currentPage.value,
      limit: pageSize.value,
      status: statusFilter.value || undefined,
      keyword: keyword.value || undefined,
      organizationType: organizationType.value || undefined,
      title: title.value || undefined
    }
    
    const response = await axios.get('/api/admin/users', { params })
    userList.value = response.data.data
    total.value = response.data.total
  } catch (error) {
    ElMessage.error('获取用户列表失败：' + error.message)
  }
}

// 处理搜索
const handleSearch = () => {
  keyword.value = searchQuery.value
  currentPage.value = 1
  fetchUserList()
}

// 处理筛选
const handleFilter = () => {
  currentPage.value = 1
  fetchUserList()
}

// 处理分页变化
const handleSizeChange = (val) => {
  pageSize.value = val
  fetchUserList()
}

const handleCurrentChange = (val) => {
  currentPage.value = val
  fetchUserList()
}

// 处理编辑
const handleEdit = (row) => {
  editForm.value = { ...row }
  dialogVisible.value = true
}

// 处理保存
const handleSave = async () => {
  try {
    const updateData = {
      profession: editForm.value.profession,
      organization: editForm.value.organization,
      purpose: editForm.value.purpose,
      institution_name: editForm.value.institution_name,
      wechat_name: editForm.value.wechat_name
    }
    
    // 如果输入了新密码，则添加到更新数据中
    if (editForm.value.password) {
      updateData.password = editForm.value.password
    }

    await axios.put(`/api/admin/users/${editForm.value.id}`, updateData)
    ElMessage.success('保存成功')
    dialogVisible.value = false
    fetchUserList()
  } catch (error) {
    ElMessage.error('保存失败：' + error.message)
  }
}

// 处理查看使用情况
const handleViewUsage = (row) => {
  selectedUser.value = row
    usageDialogVisible.value = true
}

// 处理导出
const handleExport = async () => {
  try {
    const response = await axios.get('/api/admin/users/export', {
      responseType: 'blob'
    })
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'users.xlsx')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  } catch (error) {
    ElMessage.error('导出失败：' + error.message)
  }
}

// 获取状态类型
const getStatusType = (status) => {
  const types = {
    pending: 'warning',
    approved: 'success',
    rejected: 'danger'
  }
  return types[status] || 'info'
}

// 获取状态文本
const getStatusText = (status) => {
  const texts = {
    pending: '待审核',
    approved: '已通过',
    rejected: '已拒绝'
      }
  return texts[status] || status
}

onMounted(() => {
  fetchUserList()
})
</script>

<style scoped>
.user-list {
  padding: 0.75rem;
}

@media (min-width: 768px) {
  .user-list {
    padding: 1rem;
  }
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  /* gap: 0.25rem; */
  align-items: flex-start;
}

.search-item {
  margin-bottom: 0;
  min-width: 160px;
  margin-right: 0;
}

.search-item :deep(.el-select) {
  width: 100%;
}

.search-item :deep(.el-input) {
  width: 100%;
}

.search-input :deep(.el-input__inner) {
  font-size: 0.65rem;
}

.search-input :deep(.el-input__inner::placeholder) {
  font-size: 0.6rem;
  color: #a0aec0;
}

.card-header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.75rem;
}

@media (min-width: 768px) {
  .card-header {
    flex-direction: row;
    align-items: center;
  }
}

.table-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.action-buttons {
  /* display: flex; */
  flex-wrap: wrap;
  /* gap: 0.5rem; */
  /* justify-content: flex-start; */
  align-items: center;
}

.action-buttons .el-button {
  flex-shrink: 0;
  min-width: 60px;
  /* text-align: center; */
}

.pagination-container {
  margin-top: 0.75rem;
  display: flex;
  justify-content: flex-end;
  overflow-x: auto;
}

/* 分页响应式优化 */
@media screen and (max-width: 768px) {
  .pagination-container {
    justify-content: center;
  }
  
  :deep(.el-pagination) {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  
  :deep(.el-pagination .el-pager) {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
  }
}

:deep(.el-card__header) {
  padding: 0.75rem;
}

:deep(.el-table) {
  margin-top: 0.75rem;
  font-size: 0.8125rem;
}

:deep(.el-pagination) {
  margin-top: 0.75rem;
  font-size: 0.8125rem;
}

:deep(.el-form-item__label) {
  font-size: 0.8125rem;
  line-height: 28px;
  /* width: 80px !important; */
  text-align: right;
}

:deep(.el-input__inner) {
  font-size: 0.8125rem;
  height: 28px;
  line-height: 28px;
}

:deep(.el-button) {
  font-size: 0.8125rem;
  padding: 5px 10px;
}

:deep(.el-dialog__title) {
  font-size: 0.9375rem;
}

:deep(.el-dialog__body) {
  font-size: 0.8125rem;
}

:deep(.el-tag) {
  font-size: 0.75rem;
  padding: 0 8px;
  height: 22px;
  line-height: 20px;
}

/* 响应式布局调整 */
@media screen and (max-width: 768px) {
  .search-form {
    flex-direction: column;
  }

  .search-item {
    width: 100%;
    min-width: auto;
  }

  .el-form-item {
    width: 100%;
    margin-bottom: 0.75rem;
  }

  .el-input {
    width: 100%;
  }

  .el-select {
    width: 100%;
  }

  .action-buttons {
    flex-direction: column;
    gap: 0.25rem;
  }

  .action-buttons .el-button {
    width: 100%;
    font-size: 0.75rem;
    padding: 2px 4px;
  }
}

@media screen and (max-width: 640px) {
  :deep(.el-table) {
    font-size: 0.75rem;
  }

  :deep(.el-table .cell) {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  :deep(.el-table__body-wrapper) {
    overflow-x: auto;
  }

  :deep(.el-table__header-wrapper) {
    overflow-x: auto;
  }

  :deep(.el-pagination) {
    flex-wrap: wrap;
    justify-content: center;
    font-size: 0.75rem;
  }

  :deep(.el-table-column--fixed-left) {
    z-index: 2;
  }

  :deep(.el-table-column--fixed-right) {
    z-index: 2;
  }
}

@media screen and (max-width: 480px) {
  :deep(.el-table) {
    font-size: 0.7rem;
  }

  :deep(.el-table .cell) {
    padding-left: 0.2rem;
    padding-right: 0.2rem;
  }

  :deep(.el-tag) {
    font-size: 0.65rem;
    padding: 0 4px;
    height: 18px;
    line-height: 16px;
  }

  .action-buttons .el-button {
    font-size: 0.7rem;
    padding: 1px 3px;
  }
}

/* 对话框响应式调整 */
@media screen and (max-width: 480px) {
  .edit-dialog,
  .usage-dialog {
    width: 90%;
    max-width: 320px;
  }
}

/* 响应式搜索表单 */
@media screen and (max-width: 1200px) {
  .search-item {
    min-width: 140px;
  }
}

@media screen and (max-width: 992px) {
  .search-item {
    min-width: 120px;
  }
}

/* 确保表格在小屏幕上可以水平滚动 */
@media screen and (max-width: 1200px) {
  .table-container {
    overflow-x: auto;
  }
  
  :deep(.el-table) {
    min-width: 1000px;
  }
}

@media screen and (max-width: 768px) {
  :deep(.el-table) {
    min-width: 800px;
  }
}

/* 超小屏幕优化 */
@media screen and (max-width: 375px) {
  .user-list {
    padding: 0.5rem;
  }
  
  :deep(.el-card) {
    margin-bottom: 0.5rem;
  }
  
  :deep(.el-card__header) {
    padding: 0.5rem;
  }
  
  :deep(.el-card__body) {
    padding: 0.5rem;
  }
  
  :deep(.el-table) {
    font-size: 0.65rem;
  }
  
  :deep(.el-table .cell) {
    padding-left: 0.15rem;
    padding-right: 0.15rem;
  }
  
  :deep(.el-tag) {
    font-size: 0.6rem;
    padding: 0 3px;
    height: 16px;
    line-height: 14px;
  }
  
  .action-buttons .el-button {
    font-size: 0.65rem;
    padding: 1px 2px;
  }
  
  :deep(.el-pagination) {
    font-size: 0.7rem;
  }
  
  :deep(.el-pagination .btn-prev),
  :deep(.el-pagination .btn-next) {
    padding: 0 0.5rem;
  }
}
</style>